module.exports = __webpack_public_path__ + "media/images/front/seminars/surgeon_cram_school_no5-2e0da23083cf92968bf5031ffe29e6ad.jpg";